import { render, staticRenderFns } from "./AdminContact.vue?vue&type=template&id=5c9f03ee"
import script from "./AdminContact.vue?vue&type=script&lang=js"
export * from "./AdminContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports